exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".query-area {\n  display: inline-block;\n  margin-right: 30px;\n  width: 350px; }\n\n.query-desc {\n  font-size: 1.1em;\n  margin-top: 10px;\n  margin-bottom: 20px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/containers/sales/sales.scss
// module id = ./src/app/containers/sales/sales.scss
// module chunks = 1